module.exports = __webpack_public_path__ + "img/101-d-02.prt.3779dba1.jpg";